/**
 * Labstep
 *
 * @module components/ProtocolValue/Action/View
 * @desc Edit action for protocol value
 */

import ProtocolChildRouter from 'labstep-web/containers/Router/ProtocolChild';
import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import type React from 'react';
import type { IProtocolValueActionViewProps } from './types';

export const ProtocolValueActionView: React.FC<
  IProtocolValueActionViewProps
> = ({ protocolValue, actionComponentProps }) => (
  <ProtocolChildRouter route="value_show" id={protocolValue.guid}>
    {({ navigate }) => (
      <ActionComponent
        dataCy="components/ProtocolValue/Action/View"
        type="option"
        text="Edit"
        icon="pencil"
        onClick={navigate}
        {...actionComponentProps}
      />
    )}
  </ProtocolChildRouter>
);
